"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ShieldCheck: function() {
        return ShieldCheck;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ShieldCheck = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.2929 1.29288C11.6834 0.902353 12.3166 0.902353 12.7071 1.29288C13.8001 2.38592 15.2826 2.99998 16.8284 2.99998H21C21.5523 2.99998 22 3.4477 22 3.99998V12.801C22 16.3577 19.9054 19.5808 16.6552 21.0253L12.4061 22.9138C12.1476 23.0287 11.8524 23.0287 11.5939 22.9138L7.34475 21.0253C4.0946 19.5808 2 16.3577 2 12.801V3.99998C2 3.4477 2.44772 2.99998 3 2.99998H7.17157C8.71737 2.99998 10.1999 2.38592 11.2929 1.29288ZM12 3.33362C10.6293 4.40773 8.93096 4.99998 7.17157 4.99998H4V12.801C4 15.5673 5.62914 18.0742 8.15703 19.1977L12 20.9057L15.843 19.1977C18.3709 18.0742 20 15.5673 20 12.801V4.99998H16.8284C15.069 4.99998 13.3707 4.40773 12 3.33362ZM16.6757 8.26283C17.0828 8.63602 17.1103 9.26859 16.7372 9.67571L11.2372 15.6757C11.0477 15.8823 10.7803 16 10.5 16C10.2197 16 9.95226 15.8823 9.76285 15.6757L7.26285 12.9484C6.88965 12.5413 6.91716 11.9088 7.32428 11.5356C7.73139 11.1624 8.36396 11.1899 8.73715 11.597L10.5 13.5201L15.2628 8.32426C15.636 7.91714 16.2686 7.88964 16.6757 8.26283Z",
        fill: "currentColor"
    })
}), "ShieldCheck");
const _default = ShieldCheck;
